import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all export orders
export const fetchExportOrders = createAsyncThunk(
  "export_orders/fetchAll",
  async ({ page = 1,
    reference_no = "",
    export_type = "",
    business_type = "",
    file_type = "",
    language = "",
    status = "",
    created_by_name = "",
    from_date = "",
    to_date = "",
    end_date_from = "",
    end_date_to = "" }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/export-orders?page=${page}&reference_no=${reference_no}&export_type=${export_type}&business_type=${business_type}&file_type=${file_type}&language=${language}&status=${status}&created_by_name=${created_by_name}&from_date=${from_date}&to_date=${to_date}&end_date_from=${end_date_from}&end_date_to=${end_date_to}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);
// Fetch all export orders once (for filters)
export const fetchAllExportOrders = createAsyncThunk(
  "export_orders/fetchAllFull",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/export-orders`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load all data";
      return rejectWithValue(message);
    }
  }
);

const ExportOrdersSlice = createSlice({
  name: "export_orders",
  initialState: {
    export_orders: [],
    all_export_orders: [],
    isLoading: false,
    error: null,
    success: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExportOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchExportOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.export_orders = action.payload?.data?.data || [];
        state.pagination = action.payload?.data?.pagination || null;
      })
      .addCase(fetchExportOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(fetchAllExportOrders.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchAllExportOrders.fulfilled, (state, action) => {
        state.all_export_orders = action.payload?.data?.data || [];
      })
      .addCase(fetchAllExportOrders.rejected, (state, action) => {
        state.error = action.payload || "Failed to load all export orders";
      });

  },
});

export const { clearState } = ExportOrdersSlice.actions;
export default ExportOrdersSlice.reducer;
